export default __webpack_public_path__ + "static/media/296077a3e081aad2fb33be2699587987.svg";